<div class="login-wrapper">
  <div class="page-header pt-8 pb-10 lg:py-12">
    <div class="container container-padding mx-auto">
      <div class="text-center uppercase text-5xl font-display page-header__title lines-centered-red">Update Password
      </div>
    </div>
  </div>
  <div class="container container-padding mx-auto py-1 pb-20">
    @if (isUpdateOldPassword) {
      <form [formGroup]="forgotPasswordForm" class="max-w-md mx-auto bg-white rounded-lg py-6 sm:px-10">
        <div class="mb-3 input-group">
          <label class="input-label">Old Password</label>
          <input type="password" class="input w-full" placeholder="Old Password" formControlName="OldPassword" validateEqual="ConfirmPassword" reverse="true" [ngClass]="{'input--error': forgotPasswordForm.controls.OldPassword.invalid && forgotPasswordForm.controls.OldPassword.touched}">
          <div class="input-faux-label">Old Password</div>
          @if (forgotPasswordForm.controls.OldPassword.errors) {
            <div>
              @if (forgotPasswordForm.controls.OldPassword.errors.required && forgotPasswordForm.controls.OldPassword.touched) {
                <span class="input-error-message">
                  Old Password
                  is
                  required.
                </span>
              }
              @if (forgotPasswordForm.controls.OldPassword.errors.minlength && forgotPasswordForm.controls.OldPassword.touched) {
                <span class="input-error-message">
                  Minimum
                  8
                  characters required.
                </span>
              }
              @if (forgotPasswordForm.controls.OldPassword.errors.pattern && forgotPasswordForm.controls.OldPassword.touched) {
                <span class="input-error-message">
                  Old Password
                  should contain uppercase, lowercase, number and special characters.
                </span>
              }
            </div>
          }
        </div>
        <div class="mb-3 input-group">
          <label class="input-label">Password</label>
          <input type="password" class="input w-full" placeholder="Password" formControlName="Password" autocomplete="new-password" validateEqual="ConfirmPassword" reverse="true" [ngClass]="{'input--error': forgotPasswordForm.controls.Password.invalid && forgotPasswordForm.controls.Password.touched}">
          <div class="input-faux-label">Password</div>
          @if (forgotPasswordForm.controls.Password.errors) {
            <div>
              @if (forgotPasswordForm.controls.Password.errors.required && forgotPasswordForm.controls.Password.touched) {
                <span class="input-error-message">
                  Password
                  is
                  required.
                </span>
              }
              @if (forgotPasswordForm.controls.Password.errors.minlength && forgotPasswordForm.controls.Password.touched) {
                <span class="input-error-message">
                  Minimum
                  8
                  characters required.
                </span>
              }
              @if (forgotPasswordForm.controls.Password.errors.maxlength && forgotPasswordForm.controls.Password.touched) {
                <span class="input-error-message">
                  Maximum 98 characters are allowed.
                </span>
              }
              @if (forgotPasswordForm.controls.Password.errors.pattern && forgotPasswordForm.controls.Password.touched) {
                <span class="input-error-message">
                  Password
                  should contain uppercase, lowercase, number and special characters.
                </span>
              }
            </div>
          }
        </div>
        <div class="mb-3 input-group">
          <label class="input-label">Confirm Password</label>
          <input type="password" class="input w-full" placeholder="Confirm Password" formControlName="ConfirmPassword" autocomplete="new-password" validateEqual="Password" [ngClass]="{'input--error': forgotPasswordForm.controls.ConfirmPassword.invalid && forgotPasswordForm.controls.ConfirmPassword.touched}">
          <div class="input-faux-label">Confirm Password</div>
          @if (forgotPasswordForm.controls.ConfirmPassword.errors) {
            <div>
              @if (forgotPasswordForm.controls.ConfirmPassword.errors.required && forgotPasswordForm.controls.ConfirmPassword.touched) {
                <span class="input-error-message">
                Confirm Password is required.</span>
              }
              @if (forgotPasswordForm.controls.ConfirmPassword.errors && forgotPasswordForm.controls.ConfirmPassword.touched) {
                <span class="input-error-message">
                Passwords do not match.</span>
              }
            </div>
          }
        </div>
        <div class="mt-4">
          <button class="button button--border block mb-3 w-full md:w-auto mx-auto" [disabled]="forgotPasswordForm.invalid" (click)="updateOldPassword()">Update Password</button>
        </div>
        <div class="text-center text-sm"><a (click)="navigateBack()" class="no-underline">Cancel</a></div>
      </form>
    }
    @if (!isUpdateOldPassword) {
      <form [formGroup]="verificationCodeForm" class="max-w-md mx-auto bg-white rounded-lg py-6 sm:px-10">
        <!-- Verification Code Sent -->
        <div class="text-center text-sm text-black pt-3 pb-3">The verification code has been sent to your inbox.<br> It may take a few moments.</div>
        <div class="mb-3 input-group">
          <label class="input-label">Verification Code</label>
          <input type="text" class="input w-full" placeholder="Verification Code" formControlName="VerificationCode" [ngClass]="{'input--error': verificationCodeForm.controls.VerificationCode.invalid && verificationCodeForm.controls.VerificationCode.touched}">
          <div class="input-faux-label">Verification Code</div>
          @if (verificationCodeForm.controls.VerificationCode.errors) {
            <div>
              @if (verificationCodeForm.controls.VerificationCode.errors.required && verificationCodeForm.controls.VerificationCode.touched) {
                <span class="input-error-message">
                  Verification Code is required.
                </span>
              }
              @if (verificationCodeForm.controls.VerificationCode.errors.invalid && verificationCodeForm.controls.VerificationCode.touched) {
                <span class="input-error-message">
                  Verification Code invalid.
                </span>
              }
            </div>
          }
        </div>
        <div class="mb-3 input-group">
          <label class="input-label">Password</label>
          <input type="password" class="input w-full" placeholder="Password" formControlName="Password" autocomplete="new-password" validateEqual="ConfirmPassword" reverse="true" [ngClass]="{'input--error': verificationCodeForm.controls.Password.invalid && verificationCodeForm.controls.Password.touched}">
          <div class="input-faux-label">Password</div>
          @if (verificationCodeForm.controls.Password.errors) {
            <div>
              @if (verificationCodeForm.controls.Password.errors.required && verificationCodeForm.controls.Password.touched) {
                <span class="input-error-message">
                  Password
                  is
                  required.
                </span>
              }
              @if (verificationCodeForm.controls.Password.errors.minlength && verificationCodeForm.controls.Password.touched) {
                <span class="input-error-message">
                  Minimum
                  8
                  characters required.
                </span>
              }
              @if (verificationCodeForm.controls.Password.errors.maxlength && verificationCodeForm.controls.Password.touched) {
                <span class="input-error-message">
                  Maximum 98 characters are allowed.
                </span>
              }
              @if (verificationCodeForm.controls.Password.errors.pattern && verificationCodeForm.controls.Password.touched) {
                <span class="input-error-message">
                  Password
                  should contain uppercase, lowercase, number and special characters.
                </span>
              }
            </div>
          }
        </div>
        <div class="mb-3 input-group">
          <label class="input-label">Confirm Password</label>
          <input type="password" class="input w-full" placeholder="Confirm Password" formControlName="ConfirmPassword" autocomplete="new-password" validateEqual="Password" [ngClass]="{'input--error': verificationCodeForm.controls.ConfirmPassword.invalid && verificationCodeForm.controls.ConfirmPassword.touched}">
          <div class="input-faux-label">Confirm Password</div>
          @if (verificationCodeForm.controls.ConfirmPassword.errors) {
            <div>
              @if (verificationCodeForm.controls.ConfirmPassword.errors.required && verificationCodeForm.controls.ConfirmPassword.touched) {
                <span class="input-error-message">
                Confirm Password is required.</span>
              }
              @if (verificationCodeForm.controls.ConfirmPassword.errors && verificationCodeForm.controls.ConfirmPassword.touched) {
                <span class="input-error-message">
                Passwords do not match.</span>
              }
            </div>
          }
        </div>
        <div class="mt-4">
          <button class="button button--border block mb-3 w-full md:w-auto mx-auto" [disabled]="verificationCodeForm.invalid" (click)="updatePassword()">Update Password</button>
        </div>
        <div class="text-center text-sm"><a (click)="navigateBack()" class="no-underline">Cancel</a></div>
      </form>
    }
  </div>
</div>